import { isVietnamCompany } from './vietnam';

// Role flags applied on top of a module definition so that the module matches
// only the roles allowed above. The keys mirror the flags used by the module
// filters in BookDash and AppFooter.
const VIETNAM_RESTRICTED_MODULE_ACCESS = {
  isBranchLeader: false,
  isBranchLeaderSupervisorII: false,
  isDeveloper: false,
  isSiteplan: false,
  isDeveloperSupervisor: false,
  isHeadquarters: true,
  isSuperAdmin: true,
  isAdminBasic: true,
  isAdminCommunity: true,
  isDeveloperSalesManager: false,
  isDeveloperSalesAdmin: false,
};

function hasVietnamRestrictedModuleAccess(auth = {}) {
  return Boolean(
    auth.isSuperAdmin ||
    auth.isAdminBasic ||
    auth.isAdminCommunity ||
    auth.isHeadquarters,
  );
}

// canAccessRestrictedModule tells whether Payments, Bankers and Reports may be
// reached by the signed in user.
export function canAccessRestrictedModule(auth = {}) {
  if (!isVietnamCompany(auth)) {
    return true;
  }
  return hasVietnamRestrictedModuleAccess(auth);
}

// restrictedModuleAccess returns the role flag overrides to merge into a module
// definition, or null when the company is not affected.
export function restrictedModuleAccess(auth = {}) {
  return isVietnamCompany(auth) ? VIETNAM_RESTRICTED_MODULE_ACCESS : null;
}



// WEBPACK FOOTER //
// ./src/utils/moduleAccess.js